<template>
    <section class="breeders-page">
        <h1 id="breeders" class="print-title">Breeders and Owners of horses appearing in this volume</h1>
    </section>

    <div class="break-after"></div>

    <section class="breeders-page-details">
        <DataTable class="table-horses-universal no-top-margin" :value="breeders" stripedRows>
            <Column field="fullName" header="Name" />
            <Column field="address.country.name" header="Country" />
        </DataTable>
    </section>
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";

export default {
    name: "BreedersPage",
    components: {
        DataTable,
        Column,
    },
    data() {
        return {
            alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split(""),
        };
    },
    props: {
        breeders: Array,
    },
};

</script>

<style lang="scss">
.breeders-page {
    margin-top: 50% !important;
}
</style>
